import { ApplicationTracker } from '@yggdrasil/core';

export class LMGlobalTrackerService {

  private applicationTracker: ApplicationTracker;

  public getApplicationTracker() {
    return this.applicationTracker;
  }

  public setApplicationtracker(applicationTracker: ApplicationTracker) {
    this.applicationTracker = applicationTracker;
  }
}